<template>
  <div class="content fy">
    <!-- 标题 -->
    <van-nav-bar
      left-arrow
      title="风险评测"
      @click-left="show = !show"
      :z-index="10"
      fixed></van-nav-bar>
    <div style="height: 60px"></div>

    <!-- 测试题 -->
    <van-swipe
      ref="swipe"
      :touchable="false"
      class="my-swipe"
      :show-indicators="false"
      :loop="false"
      indicator-color="white"
      @change="onSwipeChange">
      <van-swipe-item v-for="(q, qi) of questions" :key="`swipe-item-${qi}`">
        <div class="test">
          <div class="title">
            <span class="sp1">{{ q.id }}</span>
            <span class="sp2">/</span>
            <span class="sp3">{{ questions.length }}</span>
            <span class="sp4">{{ q.title }}</span>
          </div>
          <van-cell-group class="answer-list">
            <van-cell
              v-for="(a, ai) in q.itemList"
              :key="`answer-${qi}-${ai}`"
              @click="nextQuestion(q, a, qi, $event)"
              :class="{ active: answers[q.id] && answers[q.id].id == a.id }">
              <div class="pick" :name="a.item">{{ a.item }}</div>
            </van-cell>
          </van-cell-group>
        </div>
        <div class="control">
          <template v-if="qi > 0">
            <div class="start" @click="prevQuestion">上一题</div>
          </template>
          <template v-if="qi === questions.length - 1">
            <van-button
              :disabled="Object.keys(answers).length < questions.length"
              class="start"
              size="large"
              @click="submit"
              v-preventReClick
              >提交</van-button
            >
          </template>
        </div>
      </van-swipe-item>
    </van-swipe>

    <!-- Popup -->
    <van-popup
      v-model="show"
      :lock-scroll="false"
      :close-on-click-overlay="false"
      :close-on-popstate="true">
      <div class="popup-content">
        <div class="title">
          <div class="d1">还差一点就完成了，真的要现在退出吗？</div>
          <div class="d2">完成风险测评才可以购买产品哦~</div>
        </div>
        <div class="select">
          <span
            class="sp1"
            @click="
              show = false
              goableBack()
            "
            >暂时放弃</span
          >
          <span class="sp2" @click="show = !show">继续测评</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as RisksApi from "@/api/risks"
import {
  Toast,
  Cell,
  CellGroup,
  Button,
  Radio,
  RadioGroup,
  Swipe,
  SwipeItem,
  Popup
} from "vant"

export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      curIndex: 0,
      show: false, // popup
      questions: [],
      answers: {}, // 各题分数集合,
      running: false
    }
  },
  beforeRouteEnter(to, from, next) {
    RisksApi.getQuestionsAssess()
      .then((data) => {
        next((vm) => {
          vm.initData(data)
        })
      })
      .catch((e) => {
        next()
      })
  },
  beforeRouteUpdate(to, from, next) {
    RisksApi.getQuestionsAssess()
      .then((data) => {
        this.initData(data)
        next()
      })
      .catch((e) => {
        next()
      })
  },
  methods: {
    // popup
    showPopup() {
      this.show = true
    },
    initData(data) {
      this.questions = data
    },
    showError(e) {},

    /**
     * 选择答案, 且跳转到下一题
     */
    nextQuestion(q, a, qi) {
      if (this.running) {
        return
      }
      if (qi < this.questions.length - 1) {
        this.running = true
      }
      this.$set(this.answers, q.id, a)

      if (this.curIndex != qi) {
        return
      }
      setTimeout(() => {
        this.$refs.swipe.next()
      }, 300)
    },
    onSwipeChange(index) {
      this.curIndex = index
      setTimeout(() => {
        this.running = false
      }, 500)
    },
    prevQuestion() {
      this.$refs.swipe.prev()
    },

    submit() {
      let score = Object.values(this.answers).reduce((total, num) => {
        return (total.score || total) + num.score
      })
      const results = []
      for (const [key, item] of Object.entries(this.answers)) {
        results.push({ subjectId: key, answer: item })
      }

      const form = {
        score,
        answer: JSON.stringify(results)
      }

      RisksApi.postScore(form)
        .then((data) => {
          Toast("测评签名文件生成中，请稍后...")
          // this._dismissLoading();
          RisksApi.assessSign()
            .then((data) => {
              //重定向到签字页
              window.location = data
            })
            .catch((e) => {
              this._dismissLoading()
              Toast(e.msg || e.message)
            })
          // this.$router.replace({
          //   path: '/risksResults',
          //   query: Object.assign({}, this.$route.query, {
          //     resultTxt: data,
          //     score
          //   }),
          // });
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
      // this.$router.replace({ name: 'risksResults', query: { score: score } });
    }
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Popup.name]: Popup
  }
}
</script>

<style scoped lang="less">
// van-nav-bar - title
::v-deep .van-nav-bar__title {
  font-size: 15px;
  color: #333;
}
// icon
::v-deep .van-icon-arrow-left::before {
  color: #333;
}

// 整体
.content {
  // 测试题
  .test {
    margin: 0 14px;
    padding: 16px 12px;
    border-radius: 5px;
    background-color: #fff;

    .title {
      color: #fc6524;
      .sp1 {
        font-size: 25px;
      }
      .sp2 {
        margin: 0 3px;
      }
      .sp3 {
        font-size: 16px;
      }
      .sp4 {
        margin-left: 10px;
        font-weight: 700;
        letter-spacing: 0.5px;
      }
    }

    // van-radio-group
    .answer-list {
      margin-top: 20px;

      ::v-deep .van-cell {
        display: flex;
        flex-wrap: wrap;

        .pick {
          color: #666;
          font-size: 15px;
        }
      }
      .active {
        border-radius: 5px;
        background-color: #fc6524;
        // 选中后去掉下边框 白线
        &.van-cell::after {
          border: none;
        }
        .pick {
          color: #fff;
        }
      }
    }
  }

  // control
  .control {
    margin: 13px;
    .start {
      color: #999;
      font-size: 15px;
      text-align: center;
      margin-top: 20px;
    }
    .van-button {
      color: #fff;
      border-radius: 5px;
      background-color: #fc6524;
    }
  }

  .van-popup {
    border-radius: 5px;
    overflow-y: visible;
    .popup-content {
      width: 275px;
      height: 160px;
      position: relative;
      .title {
        width: 210px;
        margin: auto;
        .d1 {
          margin-top: 30px;
          font-size: 15px;
        }
        .d2 {
          font-size: 14px;
          margin-top: 8px;
          color: #666;
        }
      }

      .select {
        display: flex;
        height: 40px;
        position: absolute;
        bottom: 0;
        left: 0;

        span {
          line-height: 40px;
          text-align: center;
        }
        .sp1 {
          width: 137px;
          color: #666;
          background-color: #dcdcdc;
          border-radius: 0 0 0 5px;
        }
        .sp2 {
          width: 138px;
          color: #fff;
          background-color: #fc6524;
          border-radius: 0 0 5px 0;
        }
      }
    }
  }
}
</style>
